var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "or-popover",
    {
      attrs: {
        "data-component": "base-search-options-popup",
        placement: "bottom-start",
        trigger: _vm.trigger,
        "is-open": _vm.isPopupOpen,
      },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    _vm._l(_vm.optionsBasedOnActiveQueryParam, function (option) {
      return _c(
        "div",
        {
          key: option.key,
          attrs: { "data-option": option.key },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.onOptionClick(option)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t(option.label)) + "\n  ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }